import { useMemo } from 'react';

import useMultiPortfolioStore from 'lib/stores/multiPorto';
import { SubAccountStatus } from 'global/Securities/types/api/multiPorto';

export default function useSubAccounts() {
  const subAccountsData = useMultiPortfolioStore((s) => s.subAccountsData);
  const activeAccount = useMultiPortfolioStore((s) => s.activeAccount);
  const getSubAccounts = useMultiPortfolioStore((s) => s.getSubAccounts);

  const subAccounts = subAccountsData?.data?.sub_accounts || [];
  const canCreatePortfolio = subAccountsData?.data?.can_create_new_sub_account;
  const subAccountError = subAccountsData?.error;

  const approvedSubAccounts = useMemo(
    () =>
      subAccounts.filter(
        (sub) => sub.account_status === SubAccountStatus.APPROVED,
      ),
    [JSON.stringify(subAccounts)],
  );

  const activePortfolio = subAccounts.find(
    (sub) => sub.account_number === activeAccount,
  );

  const activeAccountName = useMemo(() => {
    if (subAccounts.length > 1 && activePortfolio) {
      return activePortfolio.portfolio_info.portfolio_name || '';
    }

    return '';
  }, [activePortfolio?.portfolio_info.portfolio_name, subAccounts.length]);

  return {
    subAccounts,
    approvedSubAccounts,
    canCreatePortfolio,
    subAccountError,
    activeAccountName,
    getSubAccounts,
  };
}
